import React, { Component } from 'react';
import DeleteAxios from '../axiosComponent/delete';
import PopupModal from '../UiComponents/popupModal';
import { Button, Modal } from 'react-bootstrap';
import DeleteModal from '../modals/deleteModal';

export class ActionButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDelete: false,
    };
  }

  setisDelete = (status) => {
    this.setState({ isDelete: status });
  };

  deleteRowDataById = () => {
    let vendor_id = +localStorage.getItem("vendorId")
    let availability_id = this.props.data.availability_id
    let obj = this.props.agGridReact.props.completeURL
      ? {
        completeURL: `${this.props.agGridReact.props.completeURL}/${this.props.data[this.props.agGridReact.props.keyIndex]
          }`,
        payload: { ...this.props.data },
      }
      : (this.props.agGridReact.props.deleteURL ?
        {
          completeURL: `${this.props.agGridReact.props.deleteURL}` + availability_id + `/vendor/` + vendor_id,
          payload: { ...this.props.data },
        }
        :
        {
          url: this.props.agGridReact.props.baseURL,
          uniqueId: this.props.data[this.props.agGridReact.props.keyIndex],
          payload: { ...this.props.data },
        });
    DeleteAxios(obj)
      .then((res) => {
        let alert = {
          type: 'success',
          messageHeader: 'Success',
          messageBody: 'Deleted successfuly.',
        };
        this.props.agGridReact.props.onDelete(alert);
      })
      .catch((err) => {
        console.log('err', err);
        let alert = {
          type: 'error',
          messageHeader: 'Error',
          messageBody: err.data?.message,
        };
        this.props.agGridReact.props.onDelete(alert);
      });
  };

  handleOpenDelete = () => {
    this.setisDelete(true);
  };

  handleCancel = () => {
    this.setisDelete(false);
  };

  handleConfirm = () => {
    this.setisDelete(false);
    this.deleteRowDataById();
  };

  render() {
    return (
      <>
        {!this.props.agGridReact.props.hideRowEdit && (
          <i
            onClick={() => this.props.agGridReact.props.onEdit(this.props.data)}
            className='fas w3-text-green fa-pen w3-button w3-border w3-border-green w3-round p-2'
          ></i>
        )}
        {!this.props.agGridReact.props.hideRowDelete && (
          <i
            onClick={this.handleOpenDelete}
            className='fas w3-text-red fa-trash w3-button w3-border w3-border-red w3-round p-2'
            style={{ margin: 2 }}
          ></i>
        )}
        {this.state.isDelete && (
          <DeleteModal open={this.state.isDelete} onClose={this.handleCancel} handleDelete={this.handleConfirm}/>
        )}
      </>
    );
  }
}

export default ActionButton;
